import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { FulfillmentPlanDetails } from '../fulfillment-plan';
import { useShipmentsPanelContext } from '../side-panel/shipments/shipments-panel-context-provider';

export const FulfillmentPlanLoader = ({ fulfillmentPlanId }) => {
  const isFulfillmentPlanLoaded = useSelector((state) => {
    return !!Global.selectEntitiesFulfillmentPlanById(state, {
      fulfillmentPlanId,
    });
  });

  const fulfillmentPlans = useShipmentsPanelContext();

  const counter = useMemo(() => {
    const selectedFulfillmentPlan = fulfillmentPlans.find((fulfillmentPlan) => {
      return fulfillmentPlan.fulfillmentPlanId === fulfillmentPlanId;
    });
    return selectedFulfillmentPlan ? selectedFulfillmentPlan.counter : 0;
  }, [fulfillmentPlanId, fulfillmentPlans]);

  return isFulfillmentPlanLoaded && <FulfillmentPlanDetails counter={counter} fulfillmentPlanCount={fulfillmentPlans.length} />;
};

FulfillmentPlanLoader.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
